// src/components/layout/MobileNav.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, PlusCircle, Sparkles, AlertTriangle, ShoppingCart, Flame } from 'lucide-react';
import { FEATURES } from '../../config/features';

export const MobileNav = ({ hasUnreadAlerts }) => {
  const location = useLocation();
  const isMarketplace = location.pathname.startsWith('/market');
  const isDzban = location.pathname.startsWith('/dzban-roku');

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-gray-200 z-50 safe-area-inset-bottom">
      {isMarketplace ? (
        // Marketplace Mobile Nav
        <div className="flex justify-around items-center py-3">
          <Link to="/market" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 ${
            location.pathname === '/market' ? 'text-emerald-600' : 'text-gray-600'
          }`}>
            <ShoppingCart size={24}/>
            <span className="text-[10px] font-semibold">Market</span>
          </Link>
          <Link to="/market/sell" className="flex flex-col items-center gap-1 -mt-6">
            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white p-4 rounded-full shadow-lg active:scale-95 transition-transform">
              <PlusCircle size={24}/>
            </div>
          </Link>
          <Link to="/" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 ${
            location.pathname === '/' ? 'text-blue-600' : 'text-gray-600'
          }`}>
            <HomeIcon size={24}/>
            <span className="text-[10px] font-semibold">Spoty</span>
          </Link>
        </div>
      ) : (
        // Spotting Mobile Nav
        <div className="flex justify-around items-center py-3">
          <Link to="/" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 ${
            location.pathname === '/' ? 'text-blue-600' : 'text-gray-600'
          }`}>
            <HomeIcon size={24}/>
            <span className="text-[10px] font-semibold">Baza</span>
          </Link>
          
          {FEATURES.DZBAN_ROKU && (
            <Link to="/dzban-roku" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 relative ${
              isDzban ? 'text-red-600' : 'text-gray-600'
            }`}>
              <Flame size={24}/>
              <span className="text-[10px] font-semibold">Dzban</span>
              <div className="absolute -top-1 -right-1 w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></div>
            </Link>
          )}
          
          <Link to="/add" className="flex flex-col items-center gap-1 -mt-6">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-4 rounded-full shadow-lg active:scale-95 transition-transform">
              <PlusCircle size={24}/>
            </div>
          </Link>
          
          <Link to="/exclusive" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 ${
            location.pathname === '/exclusive' ? 'text-amber-600' : 'text-gray-600'
          }`}>
            <Sparkles size={24}/>
            <span className="text-[10px] font-semibold">Exclusive</span>
          </Link>
          
          <Link to="/alert" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 relative ${
            location.pathname === '/alert' ? 'text-red-600' : 'text-gray-600'
          }`}>
            <AlertTriangle size={24}/>
            <span className="text-[10px] font-semibold">Alert</span>
            {hasUnreadAlerts && (
              <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
            )}
          </Link>
          
          <Link to="/market" className={`flex flex-col items-center gap-1 transition-transform active:scale-95 ${
            location.pathname.startsWith('/market') ? 'text-emerald-600' : 'text-gray-600'
          }`}>
            <ShoppingCart size={24}/>
            <span className="text-[10px] font-semibold">Market</span>
          </Link>
        </div>
      )}
    </nav>
  );
};